/**
 * A URL da foto com as barras repetidas do caminho colapsadas. O hotels-api
 * concatenava `PLACE_SERVICE_URL` com o caminho e gerava
 * `https://voll-places…//google-photo/…`, que o voll-places responde com 404
 * (#4359). A origem foi corrigida, mas os blocos já persistidos guardam a URL
 * quebrada; por isso o conserto fica na leitura. URL que não parseia passa
 * intacta: quem decide o que fazer com ela é o fallback da imagem.
 */
export function hotelPhotoUrl(url: string): string {
  const pathStart = url.indexOf('://') + 3;
  if (!url.includes('//', pathStart)) return url;
  try {
    const parsed = new URL(url);
    parsed.pathname = parsed.pathname.replaceAll(/\/{2,}/g, '/');
    return parsed.toString();
  } catch {
    return url;
  }
}
